import React from "react";
import { formatDateDisplay, parseCurrency } from "../../utils/currency";
import { FaDownload, FaPrint } from "react-icons/fa";

// Türkçe karakterleri doğru şekilde büyük harfe çeviren fonksiyon
const turkishToUpperCase = (str) => {
  if (!str) return str;
  
  return str
    .replace(/i/g, 'İ')
    .replace(/ı/g, 'I')
    .replace(/ğ/g, 'Ğ')
    .replace(/ü/g, 'Ü')
    .replace(/ş/g, 'Ş')
    .replace(/ö/g, 'Ö')
    .replace(/ç/g, 'Ç')
    .toUpperCase();
};


const MakbuzModal = ({ makbuzData, closeModal }) => {
  if (!makbuzData) {
    return null;
  }


  const {
    student,
    installment,
    paymentDate,
    receiptDate,
    receiptNumber,
    totalAmount,
    paymentMethod,
    paymentPerson,
    receiptUser,
  } = makbuzData;

  // Ödeme yapan kişi bilgisini formatla
  const getPaymentPersonName = () => {
    if (paymentPerson === "anne") {
      const anneName = student.parent_name || student.mother_name || "Anne";
      return anneName;
    } else if (paymentPerson === "baba") {
      const babaName = student.father_name || "Baba";
      return babaName;
    } else if (paymentPerson === "diger") {
      return "Diğer";
    }
    return "Belirtilmemiş";
  };

  const handleDownloadPDF = () => {
    // Makbuz içeriğini al
    const makbuzContainer = document.getElementById('makbuz-container');
    if (!makbuzContainer) {
      alert('Makbuz içeriği bulunamadı!');
      return;
    }

    // HTML2PDF ile PDF oluştur - A5 Yatay Format
    const opt = {
      margin: 0, // container zaten 200mm x 140mm
      filename: `makbuz_${receiptNumber.replace(/[()]/g, '').replace(/\s+/g, '_')}_${student.name}_${student.surname}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2, // netlik için
        useCORS: true,
        allowTaint: false,
        letterRendering: true,
        backgroundColor: '#ffffff',
        scrollX: 0,
        scrollY: 0,
      },
      jsPDF: {
        unit: 'mm',
        format: [210, 148],
        orientation: 'landscape',
        compress: true
      },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    };

    // PDF oluştur ve indir
    if (window.html2pdf) {
      window.html2pdf()
        .set(opt)
        .from(makbuzContainer)
        .save();
    } else {
      // Fallback: Basit HTML to PDF
      const printContent = makbuzContainer.innerHTML;
      const printWindow = window.open('', '_blank');
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Makbuz - ${receiptNumber}</title>
            <style>
              * { margin: 0; padding: 0; box-sizing: border-box; }
              body { font-family: Arial, sans-serif; background: white; }
              .container { max-width: 800px; margin: 0 auto; padding: 20px; }
              table { width: 100%; border-collapse: collapse; margin: 10px 0; }
              th, td { border: 1px solid #333; padding: 8px; text-align: center; }
              .header { text-align: center; margin-bottom: 20px; }
              .logo { max-width: 100px; height: auto; }
              .title { font-size: 18px; font-weight: bold; margin: 10px 0; }
              .info { margin: 15px 0; }
              .signature { margin-top: 30px; text-align: right; }
            </style>
          </head>
          <body>
            <div class="container">
              ${printContent}
            </div>
          </body>
        </html>
      `);
      printWindow.document.close();
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 250);
    }
  };

  const handlePrint = () => {
    // Makbuz içeriğini al
    const makbuzContainer = document.getElementById('makbuz-container');
    if (!makbuzContainer) {
      alert('Makbuz içeriği bulunamadı!');
      return;
    }

    // Yeni pencere aç ve sadece makbuz içeriğini yazdır
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Makbuz Yazdır</title>
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            
            body {
              margin: 0;
              padding: 0;
              background: white;
              font-family: Arial, sans-serif;
            }
            
            @page {
              size: A5 landscape;
              margin: 0;
            }
            
            @media print {
              body {
                margin: 0 !important;
                padding: 0 !important;
              }
              
              .makbuz-container {
                width: 200mm !important;
                height: 140mm !important;
                margin: 0 !important;
                padding: 8mm !important;
                border: none !important;
                border-radius: 0 !important;
                box-shadow: none !important;
                page-break-inside: avoid !important;
              }
            }
            
            .makbuz-container {
              width: 200mm;
              height: 140mm;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: flex-start;
              border-radius: 10px;
              border: 2px solid #333;
              margin: 0 auto;
              background-color: white;
              box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
              padding: 8mm;
              font-size: 12px;
            }
          </style>
        </head>
        <body>
          <div class="makbuz-container">
            ${makbuzContainer.innerHTML}
          </div>
          <script>
            window.onload = function() {
              // A5 yatay formatı için yazdırma ayarları
              window.print();
              window.onafterprint = function() {
                window.close();
              };
            };
          </script>
        </body>
      </html>
    `);
    
    printWindow.document.close();
  };

  return (
    <>


      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 modal-overlay">
        <div className="bg-white rounded-lg shadow-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto modal-content">
          {/* Modal Header */}
          <div className="flex justify-between items-center p-4 border-b print:hidden modal-header">
            <h2 className="text-xl font-bold text-gray-800">Makbuz Şablonu</h2>
            <div className="flex gap-2">
              <button
                onClick={handleDownloadPDF}
                className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors flex items-center gap-2"
              >
                <FaDownload className="text-sm" />
                Makbuzu İndir
              </button>
              <button
                onClick={handlePrint}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors flex items-center gap-2"
              >
                <FaPrint className="text-sm" />
                Yazdır
              </button>
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 transition-colors"
              >
                Kapat
              </button>
            </div>
          </div>

          {/* Makbuz Content */}
          <div className="p-4">
            <div
              id="makbuz-container"
              style={{
                width: "200mm",
                height: "140mm",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                borderRadius: "10px",
                border: "2px solid #333",
                margin: "0 auto",
                backgroundColor: "white",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                padding: "8mm",
                fontSize: "12px",
              }}
            >
              <div
                id="makbuz-header"
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                  borderBottom: "2px solid #333",
                  padding: "8px",
                  marginBottom: "12px",
                }}
              >
                <div
                  id="makbuz-header-left"
                  style={{ width: "100%", textAlign: "center" }}
                >
                  <p style={{ margin: "2px 0", fontSize: "12px" }}>
                  ESN AKADEMİ SOSYAL ETKİNLİK VE GELİŞİM MERKEZİ
                  </p>
                  <p
                    style={{
                      margin: "2px 0",
                      fontSize: "16px",
                      color: "#2563eb",
                    }}
                  >
                    TAHSİLAT MAKBUZU
                  </p>
                </div>
              </div>

              <div
                id="makbuz-body"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  gap: "12px",
                }}
              >
                <div
                  id="makbuz-body-top"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    fontWeight: "bold",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    width: "100%",
                    gap: "15px",
                  }}
                >
                  <div
                    id="makbuz-body-top-left"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      flex: 1,
                    }}
                  >
                    <div style={{ marginBottom: "6px" }}>
                      <p style={{ margin: "2px 0", fontSize: "10px" }}>
                        <strong>EĞİTİM DÖNEMİ :</strong>{" "}
                        {student.period || "2025-2026"}
                      </p>
                    </div>
                    <div style={{ marginBottom: "6px" }}>
                      <p style={{ margin: "2px 0", fontSize: "10px" }}>
                        <strong>ÖĞRENCİ NO :</strong>{" "}
                        {student.student_number || "---"}
                      </p>
                    </div>
                    <div style={{ marginBottom: "6px" }}>
                      <p style={{ margin: "2px 0", fontSize: "10px" }}>
                        <strong>ADI SOYADI :</strong> {student.name}{" "}
                        {student.surname}
                      </p>
                    </div>
                    <div style={{ marginBottom: "6px" }}>
                      <p style={{ margin: "2px 0", fontSize: "10px" }}>
                        <strong>TELEFON :</strong> {student.phone || "---"}
                      </p>
                    </div>
                  </div>

                  <div
                    id="makbuz-body-top-right"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      flex: 1,
                    }}
                  >
                    <div style={{ marginBottom: "6px" }}>
                      <p style={{ margin: "2px 0", fontSize: "10px" }}>
                        <strong>ÖDEME TARİHİ :</strong>{" "}
                        {formatDateDisplay(paymentDate)}
                      </p>
                    </div>
                    <div style={{ marginBottom: "6px" }}>
                      <p style={{ margin: "2px 0", fontSize: "10px" }}>
                        <strong>MAKBUZ NO :</strong> {receiptNumber}
                      </p>
                    </div>
                    <div style={{ marginBottom: "6px" }}>
                      <p style={{ margin: "2px 0", fontSize: "10px" }}>
                        <strong>ÖDEME YAPAN :</strong> {getPaymentPersonName()}
                      </p>
                    </div>
                    <div
                      style={{
                        border: "2px solid #333",
                        padding: "8px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "5px",
                        textAlign: "center",
                      }}
                    >
                      <p
                        style={{
                          margin: "2px 0",
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "#2563eb",
                        }}
                      >
                        ÖDEME TUTARI : #{totalAmount}# TL
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  id="makbuz-body-second"
                  style={{
                    width: "100%",
                    padding: "8px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "5px",
                    border: "1px solid #dee2e6",
                  }}
                >
                  <p
                    style={{ margin: "0", fontSize: "10px", lineHeight: "1.3" }}
                  >
                    Sn.{" "}
                    <strong>
                      {getPaymentPersonName()}
                    </strong>
                    {" "}tarafından yukarıda bilgileri yazılı olan sözleşme taksitlerine
                    istinaden <strong>{formatDateDisplay(paymentDate)}</strong>{" "}
                    tarihinde <strong>{paymentMethod}</strong> ile{" "}
                    <strong>#{totalAmount}# TL</strong> tahsil edilmiştir.
                  </p>
                </div>

                <div
                  id="makbuz-body-third"
                  style={{
                    width: "100%",
                    border: "2px solid #333",
                    padding: "12px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "5px",
                  }}
                >
                  <p
                    style={{
                      margin: "2px 0",
                      fontSize: "10px",
                      fontWeight: "bold",
                    }}
                  >
                    Ödemeyi Alan
                  </p>
                  <p
                    style={{
                      margin: "2px 0",
                      fontSize: "10px",
                      textAlign: "center",
                    }}
                  >
                    ESN AKADEMİ SOSYAL ETKİNLİK VE GELİŞİM MERKEZİ
                  </p>
                  <p
                    style={{
                      margin: "2px 0",
                      fontSize: "11px",
                      fontWeight: "bold",
                      color: "#2563eb",
                    }}
                  >
                    {turkishToUpperCase(receiptUser || "Nizamettin Şeherli")}
                  </p>
                </div>

                <div
                  id="makbuz-table"
                  style={{
                    width: "100%",
                    border: "2px solid #333",
                    borderRadius: "5px",
                    overflow: "hidden",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "9px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{ backgroundColor: "#2563eb", color: "white" }}
                      >
                        <th
                          style={{
                            padding: "4px",
                            border: "1px solid #333",
                            textAlign: "center",
                          }}
                        >
                          Taksit No
                        </th>
                        <th
                          style={{
                            padding: "4px",
                            border: "1px solid #333",
                            textAlign: "center",
                          }}
                        >
                          Vade Tarihi
                        </th>
                        <th
                          style={{
                            padding: "4px",
                            border: "1px solid #333",
                            textAlign: "center",
                          }}
                        >
                          Ödenen Tutar
                        </th>
                        <th
                          style={{
                            padding: "4px",
                            border: "1px solid #333",
                            textAlign: "center",
                          }}
                        >
                          Ödeme Türü
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {makbuzData.paidInstallments && makbuzData.paidInstallments.length > 0 ? (
                        makbuzData.paidInstallments.map((installment, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                padding: "4px",
                                border: "1px solid #333",
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                            >
                              {installment.id}
                            </td>
                            <td
                              style={{
                                padding: "4px",
                                border: "1px solid #333",
                                textAlign: "center",
                              }}
                            >
                              {formatDateDisplay(installment.dueDate)}
                            </td>
                            <td
                              style={{
                                padding: "4px",
                                border: "1px solid #333",
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                            >
                              {installment.amount} ₺
                            </td>
                            <td
                              style={{
                                padding: "4px",
                                border: "1px solid #333",
                                textAlign: "center",
                                fontSize: "8px",
                              }}
                            >
                              {installment.paymentType}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            style={{
                              padding: "4px",
                              border: "1px solid #333",
                              textAlign: "center",
                              fontWeight: "bold",
                            }}
                          >
                            {installment.id}
                          </td>
                          <td
                            style={{
                              padding: "4px",
                              border: "1px solid #333",
                              textAlign: "center",
                            }}
                          >
                            {formatDateDisplay(installment.dueDate)}
                          </td>
                          <td
                            style={{
                              padding: "4px",
                              border: "1px solid #333",
                              textAlign: "center",
                              fontWeight: "bold",
                            }}
                          >
                            {installment.amount} ₺
                          </td>
                          <td
                            style={{
                              padding: "4px",
                              border: "1px solid #333",
                              textAlign: "center",
                            }}
                          >
                            Normal Ödeme
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div
                  id="makbuz-body-fourth"
                  style={{
                    width: "100%",
                    padding: "8px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "5px",
                    border: "1px solid #dee2e6",
                    fontSize: "9px",
                    lineHeight: "1.2",
                  }}
                >
                  <p style={{ margin: "0" }}>
                    <strong>{student.id || "---"}</strong> numaralı sözleşme
                    için <strong>{formatDateDisplay(paymentDate)}</strong>{" "}
                    tarihinde <strong>{receiptNumber}</strong> belge no ile
                    yaptığınız{" "}
                    <strong>
                      #{totalAmount}# TL ({paymentMethod})
                    </strong>{" "}
                    ödemesinden sonra; sözleşmenizden kalan toplam borç tutarı{" "}
                    <strong>
                      #
                      {makbuzData.remainingTotalDebt ||
                        Math.max(
                          0,
                          parseFloat(installment.originalAmount || installment.amount) -
                            parseCurrency(totalAmount)
                        )}
                      # TL
                    </strong>
                    'dir.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MakbuzModal;
